/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CurrencyMaskInputMode } from 'ngx-currency';
import { Router } from "@angular/router";

@Component({
    selector: 'app-toolkit-progetto-tab-anagrafica-progetto',
    templateUrl: './tab-anagrafica-progetto.component.html',
})
export class ToolkitGestioneProgettoTabAnagraficaProgettoComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    readonly natural = CurrencyMaskInputMode.NATURAL;

    currentPath: string;

    disabledLabel: boolean;

    constructor(private router: Router) {
        
    }

    ngOnInit() {
        if (this.canEdit === false) {
            this.formGroup.disable();
        }
        this.formGroup?.get('importoEuro')?.disable();
        this.formGroup?.get('denominazione')?.disable();
        this.formGroup?.get('descrizione')?.disable();
        this.formGroup?.get('amministrazioneAggiudicatrice')?.disable();
        this.currentPath = this.router.url;
        this.disabledLabel=true;
    }

}
